// extracted by mini-css-extract-plugin
module.exports = {"TextContent":"styles_TextContent__4GP4x"};